/**
 * Central react-query key factory + pure param builders for the Attendance
 * feature. The shared `['attendance']` prefix is the single lever that replaces
 * the old window-event refresh bus: one
 *   queryClient.invalidateQueries({ queryKey: attendanceKeys.all })
 * refetches every active attendance query.
 */

export const attendanceKeys = {
  all: ['attendance'],
  list: (params) => ['attendance', 'list', params],
  summary: (params) => ['attendance', 'summary', params],
  kpis: (range) => ['attendance', 'kpis', range],
  timesheet: (params) => ['attendance', 'timesheet', params],
  day: (params) => ['attendance', 'day', params],
  calculate: (params) => ['attendance', 'calculate', params],
};

// ---- Pure param builders (mirror the current in-component fetch params) ------

/** Raw attendance-list params, matching AttendanceList.fetchData. */
export const listParams = ({ filters = {}, page = 0, rowsPerPage = 10, grouped = false } = {}) => ({
  ...filters,
  page: page + 1,
  per_page: grouped ? Math.max(rowsPerPage * 25, 250) : rowsPerPage,
});

/** Report-summary params (grouped view / dashboard), omitting an empty code. */
export const summaryParams = ({ employee_code, from, to } = {}) => ({
  employee_code: employee_code || undefined,
  from,
  to,
});
